"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ComboOption.css");
var icons = require("../../../../../styles/att-icons.css");
var key_press_1 = require("../../../../../utils/key-press");
var enterIsPressed = key_press_1.KeyPress.enterIsPressed;
var Option = /** @class */ (function (_super) {
    __extends(Option, _super);
    function Option(props) {
        var _this = _super.call(this, props) || this;
        _this.setLiRef = _this.setLiRef.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        return _this;
    }
    Option.prototype.handleClick = function () {
        if (this.props.onSelect) {
            this.props.onSelect(this.props.data.choice, false);
        }
    };
    Option.prototype.handleKeyDown = function (e) {
        // console.log('handel key down in option component');
        if (enterIsPressed(e)) {
            // console.log('handel key down in option component: enter key');
            var elem = e.target;
            elem.parentElement.parentElement.parentElement.children[0].focus();
            if (this.props.onSelect) {
                this.props.onSelect(this.props.data.choice, true);
            }
        }
        else if (this.props.handelKeyDown) {
            this.props.handelKeyDown(e);
        }
    };
    Option.prototype.setLiRef = function (element) {
        this.liRef = element;
    };
    Option.prototype.render = function () {
        var _a = this.props.data, choice = _a.choice, isSelected = _a.isSelected;
        var isRedesign = this.props.options && this.props.options.isRedesign;
        var classes = isSelected && !isRedesign ? [styles.menuItem, styles.menuItemSelected].join(' ') : styles.menuItem;
        if (this.props.options && this.props.options.showCircle) {
            classes += " " + styles.seprater;
        }
        if (choice && choice.showRightArrow) {
            classes += " " + styles.rightArrow;
        }
        var text = choice.displayText ? choice.displayText : choice.value.toString();
        var subStrIndex = this.props.data && this.props.data.textData ?
            text.toUpperCase().indexOf(this.props.data.textData.toUpperCase()) + this.props.data.textData.length : 0;
        var primary1stText = text.substring(0, subStrIndex);
        var primary2ndText = text.substring(subStrIndex, text.length);
        var primaryText = React.createElement("span", null, text);
        if (this.props.options && this.props.options.heighlightTextData) {
            primaryText = (React.createElement(React.Fragment, null,
                React.createElement("span", { className: styles.primaryTextBold, dangerouslySetInnerHTML: {
                        __html: primary1stText ? primary1stText.split(' ').join('&nbsp;') :
                            primary1stText,
                    } }),
                React.createElement("span", { className: styles.primaryText, dangerouslySetInnerHTML: {
                        __html: primary2ndText ? primary2ndText.replace(' ', '&nbsp;') :
                            primary2ndText,
                    } })));
        }
        var secondaryText = choice.secondaryDisplayText ?
            React.createElement("span", { className: styles.secondoryText },
                ",\u00A0",
                choice.secondaryDisplayText) : '';
        var showRightArrow = choice.showRightArrow ?
            React.createElement("span", null,
                React.createElement("i", { className: [styles.chevronIcon, icons.attIcon, icons.attIconRight].join(' ') })) : '';
        return (React.createElement("li", { id: text, "data-test-id": this.props.testId, className: classes, role: "menuitem", title: text, tabIndex: 0, onClick: this.handleClick, "aria-selected": isSelected, ref: this.setLiRef, onKeyDown: this.handleKeyDown },
            primaryText,
            secondaryText,
            showRightArrow));
    };
    return Option;
}(React.Component));
exports.default = Option;
//# sourceMappingURL=ComboOption.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ComboBox/components/ComboOption/ComboOption.js
// module id = 512
// module chunks = 8